<script setup lang="ts">
import { Handshake, EyeOff, CalendarClock } from 'lucide-vue-next'
const offerings = [
  {
    icon: Handshake,
    title: 'Agency partnerships',
    description: 'Experienced Laravel developers for your client projects, working in your workflow and joining client calls under your banner.',
  },
  {
    icon: EyeOff,
    title: 'White label development',
    description: 'We build under your brand and your clients never know we exist: your repos, your pipeline, full confidentiality.',
  },
  {
    icon: CalendarClock,
    title: 'Contract & subcontracting',
    description: 'Short or long engagements to fill a skill gap or meet a deadline, working inside your existing team and processes.',
  },
]
</script>

<template>
  <section id="agencies" class="py-20 md:py-40 relative">
    <div class="max-w-7xl mx-auto px-6 md:px-12">
      <div class="grid lg:grid-cols-2 gap-16 lg:gap-20 items-center">
        <!-- Left: Content -->
        <div data-aos="fade">
          <div class="flex items-center gap-3 mb-6">
            <span class="text-xs tracking-[0.25em] text-blu-900 dark:text-blu-400 uppercase font-medium">Partnerships</span>
          </div>

          <h2 class="text-4xl md:text-5xl lg:text-6xl font-bold text-slate-700 dark:text-white mb-6">
            For agencies
          </h2>

          <p class="text-lg md:text-xl text-slate-700/80 dark:text-white/65 leading-relaxed text-pretty max-w-xl">
            We partner with agencies, freelancers and in-house teams across the UK and beyond who need reliable Laravel expertise. Based in Edinburgh, available in any time zone.
          </p>
        </div>

        <!-- Right: the ways we work with agencies, as rows divided by
             hairlines, on the same dot stage as the other sections. -->
        <VisualStage>
          <ul class="relative divide-y divide-slate-900/10 dark:divide-white/10">
            <li v-for="(offering, index) in offerings" :key="offering.title" data-aos="fade" :data-aos-delay="150 + index * 120" class="px-3 py-6">
              <div class="flex items-center gap-3">
                <component :is="offering.icon" class="h-5 w-5 shrink-0 text-blu-600 dark:text-blu-400" />
                <h3 class="text-lg font-semibold text-slate-700 dark:text-white">{{ offering.title }}</h3>
              </div>
              <p class="mt-2 text-[15px] leading-relaxed text-slate-700/75 dark:text-white/55">{{ offering.description }}</p>
            </li>
          </ul>
        </VisualStage>
      </div>
    </div>
  </section>
</template>
